import { render, staticRenderFns } from "./PromoteWithdrawalRecord.vue?vue&type=template&id=5fd67ca8&scoped=true&"
import script from "./PromoteWithdrawalRecord.vue?vue&type=script&lang=js&"
export * from "./PromoteWithdrawalRecord.vue?vue&type=script&lang=js&"
import style0 from "./PromoteWithdrawalRecord.vue?vue&type=style&index=0&id=5fd67ca8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd67ca8",
  null
  
)

export default component.exports